import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.0391 12.2169L14.332 3.50977L12.9177 4.92398L19.2106 11.2169L2.62485 11.2169L2.62485 13.2169L19.2106 13.2169L12.9177 19.5098L14.332 20.924L23.0391 12.2169Z",
		fill: "#395566"
	})
});
export default SvgLine;
